import { ReactNode } from 'react';

interface iProps {
  children: ReactNode;
}

export const OrganismWarning = ({ children }: iProps) => (
  <div className="text-sm font-bold bg-candlelight p-4 mb-4">{children}</div>
);
